import React from 'react';
import Button from '../../Shared/UI/Button/components/Button';
import ButtonGroup from '../../Shared/UI/ButtonGroup/components/ButtonGroup';
import Link from '../../Shared/UI/Link/components/Link';
import { useCapabilities } from '../../Shared/capabilities';

import styles from './DiscourseNavigation.module.scss';

const DiscourseNavigation = ({
  viewState,
  onViewStateChange,
  viewStateOptions,
}) => {
  const capabilities = useCapabilities();
  const hasViewStateFilter = viewStateOptions && viewStateOptions.length > 0;

  return (
    <nav className={styles.discourseNavigation}>
      <div className={styles.filterSection}>
        {hasViewStateFilter && (
          <ButtonGroup>
            {viewStateOptions.map((option) => (
              <Button
                key={option.value}
                variant="secondary"
                pressed={viewState === option.value}
                onClick={() => onViewStateChange(option.value)}
              >
                {option.label}
              </Button>
            ))}
          </ButtonGroup>
        )}
      </div>

      <div className={styles.pageLinks}>
        {capabilities.showAdminDiscourseNavigation && (
          <Link href="/discourse/admin" variant="nav">
            Admin
          </Link>
        )}
        {capabilities.showPublishedDiscourseNavigation && (
          <Link href="/discourse/published" variant="nav">
            Published
          </Link>
        )}
        {capabilities.showYourDiscourseNavigation && (
          <Link href="/discourse/your" variant="nav">
            Your Discourse
          </Link>
        )}
        {capabilities.showNewDiscourseNavigation && (
          <Link href="/discourse/new" variant="nav">
            + New
          </Link>
        )}
      </div>
    </nav>
  );
};

export default DiscourseNavigation;
